import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import detector from "i18next-browser-languagedetector";
import Backend from "i18next-xhr-backend";
import "./Config/language/en-US.json";
import "./Config/language/zh-HK.json";

i18n
  .use(Backend)
  .use(detector)
  .use(initReactI18next)
  .init({
    whitelist: ["en-US", "zh-HK"],
    fallbackLng: "en-US",
    load: "currentOnly",
    backend: {
      // for all available options read the backend's repository readme file
      loadPath: "./assets/config/{{lng}}.json"
    },
    // lng: "en-US",

    //debug: true,
    ns: ["translations"],
    saveMissing: false,
    keySeparator: false,

    interpolation: {
      escapeValue: false
    },
    react: {
      wait: false,
      nsMode: "fallback"
    }
  });

export default i18n;
